/* Modified by: Ishan | Soft-contrast gradient for billboard detail CTA buttons */
export const CTA_GRADIENT =
  'linear-gradient(135deg, #3B66B8 0%, #8156B4 100%)';

export const DETAIL_AUTO_SLIDE_MS = 4000;
